const inlineTags = ["ul", "ol", "div"];
export {
  inlineTags
};
//# sourceMappingURL=types.js.map
